import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

// Visible breadcrumb trail. The matching BreadcrumbList structured data is emitted
// server-side via /public/seo, so users and search engines share one hierarchy.
export function Breadcrumbs({ items = [], className = "" }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={`text-sm ${className}`}>
      <ol className="flex items-center flex-wrap gap-1.5 text-slate-500">
        <li>
          <Link to="/" data-testid="breadcrumb-home" className="inline-flex items-center gap-1 hover:text-primary transition-colors">
            <Home className="w-3.5 h-3.5" /> Home
          </Link>
        </li>
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              <ChevronRight className="w-3.5 h-3.5 text-slate-300" />
              {it.to && !last ? (
                <Link to={it.to} className="hover:text-primary transition-colors">{it.label}</Link>
              ) : (
                <span className="text-slate-700 font-medium" aria-current="page">{it.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
